module.exports = __webpack_public_path__ + "img/all-fence.7da7703c.svg";